import { APP_BASE_URL, CDN_BASE_URL } from '@/constants'

export default {
  openGraph: {
    url: APP_BASE_URL,
    type: 'website',
    locale: 'ko_KR',
    site_name: 'Linq',
    title: 'Linq',
    description: '',
    images: [
      {
        url: `${CDN_BASE_URL}/linqalpha_og_image.png`,
        width: 800,
        height: 400,
        alt: 'Og Image Alt',
      },
    ],
  },
  twitter: {
    site: 'Linq',
  },
}
